<template>
  <div class="query-stats">
    <h1>查询统计</h1>
    <div class="stats-container">
      <!-- Daily Stats -->
      <div class="stats-card">
        <h2>每日统计</h2>
        <div class="form-group">
          <label for="daily-date">选择日期:</label>
          <input type="date" id="daily-date" v-model="dailyDate" class="date-picker">
          <button @click="fetchDailyStats" :disabled="isLoadingDaily" class="action-btn">
            <i class="fas fa-search"></i>
            {{ isLoadingDaily ? '查询中...' : '查询' }}
          </button>
        </div>
        <div v-if="isLoadingDaily" class="loading-spinner"></div>
        <div v-if="dailyError" class="error-message">{{ dailyError }}</div>
        <div v-if="dailyStats.length" class="stats-table-container">
          <table class="stats-table">
            <thead>
              <tr>
                <th>来源</th>
                <th>查询次数</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="stat in dailyStats" :key="stat.source">
                <td>{{ stat.source }}</td>
                <td>{{ stat.query_count }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Range Stats -->
      <div class="stats-card">
        <h2>范围统计</h2>
        <div class="form-group">
          <label for="start-date">开始日期:</label>
          <input type="date" id="start-date" v-model="startDate" class="date-picker">
          <label for="end-date">结束日期:</label>
          <input type="date" id="end-date" v-model="endDate" class="date-picker">
          <button @click="fetchRangeStats" :disabled="isLoadingRange" class="action-btn">
            <i class="fas fa-search"></i>
            {{ isLoadingRange ? '查询中...' : '查询' }}
          </button>
        </div>
        <div v-if="isLoadingRange" class="loading-spinner"></div>
        <div v-if="rangeError" class="error-message">{{ rangeError }}</div>
        <div v-if="rangeStats.length" class="stats-table-container">
          <table class="stats-table">
            <thead>
              <tr>
                <th>日期</th>
                <th>来源</th>
                <th>查询次数</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="stat in rangeStats" :key="stat.id">
                <td>{{ formatDate(stat.date) }}</td>
                <td>{{ stat.source }}</td>
                <td>{{ stat.query_count }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API_BASE_URL } from '../config/api';

export default {
  name: 'QueryStats',
  data() {
    return {
      dailyDate: new Date().toISOString().slice(0, 10),
      startDate: '',
      endDate: '',
      dailyStats: [],
      rangeStats: [],
      isLoadingDaily: false,
      isLoadingRange: false,
      dailyError: null,
      rangeError: null,
    };
  },
  methods: {
    async fetchDailyStats() {
      this.isLoadingDaily = true;
      this.dailyError = null;
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE_URL}/admin/stats/daily?date=${this.dailyDate}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || '获取每日统计失败');
        }
        const data = await response.json();
        this.dailyStats = data.data;
      } catch (error) {
        this.dailyError = error.message;
      } finally {
        this.isLoadingDaily = false;
      }
    },
    async fetchRangeStats() {
      if (!this.startDate || !this.endDate) {
        this.rangeError = '请选择开始和结束日期';
        return;
      }
      this.isLoadingRange = true;
      this.rangeError = null;
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE_URL}/admin/stats/range?start_date=${this.startDate}&end_date=${this.endDate}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || '获取范围统计失败');
        }
        const data = await response.json();
        this.rangeStats = data.data;
      } catch (error) {
        this.rangeError = error.message;
      } finally {
        this.isLoadingRange = false;
      }
    },
    formatDate(dateString) {
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(dateString).toLocaleDateString('zh-CN', options);
    },
  },
};
</script>

<style scoped>
.query-stats {
  padding: 2rem;
  background-color: #f4f7f9;
}

h1 {
  text-align: center;
  color: #333;
  margin-bottom: 2rem;
}

.stats-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.stats-card {
  background-color: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

h2 {
  color: #444;
  margin-bottom: 1.5rem;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
}

.form-group {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.date-picker {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.action-btn {
  padding: 0.5rem 1rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.action-btn:hover {
  background-color: #0056b3;
}

.action-btn:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin: 2rem auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-message {
  color: #d9534f;
  background-color: #f2dede;
  border: 1px solid #ebccd1;
  padding: 1rem;
  border-radius: 4px;
  margin-top: 1rem;
}

.stats-table-container {
  margin-top: 1.5rem;
  overflow-x: auto;
}

.stats-table {
  width: 100%;
  border-collapse: collapse;
}

.stats-table th, .stats-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.stats-table th {
  background-color: #f8f9fa;
}
</style>